import { changePage } from "./app";
import * as types from "../constants/ActionTypes";

export function studentSelectedSuccess(response: any) 
{
    return {
        type: types.SELECT_STUDENT,
        payload: {
            response: response
        },
    };
}

export function selectStudent(student: any) 
{
    return (dispatch: any) =>
    {
        dispatch(studentSelectedSuccess(student));
        dispatch(changePage("other"));
    };
}